import { type Control, Controller, type FieldValues, type Path } from 'react-hook-form';
import TextArea, { type TextAreaProps } from '../TextArea';

interface Props<T extends FieldValues> extends TextAreaProps {
  name: Path<T>;
  control: Control<T>;
}

export default function <T extends FieldValues>({
  name,
  label,
  placeholder,
  control,
  isRequired = false,
  rows,
  ...props
}: Props<T>) {
  return (
    <Controller
      name={name}
      control={control}
      rules={{ required: isRequired ? 'Required' : false }}
      render={({ field, fieldState: { error } }) => (
        <TextArea
          label={label}
          placeholder={placeholder}
          {...field}
          error={error?.message}
          isRequired={isRequired}
          rows={rows}
          {...props}
        />
      )}
    />
  );
}
